import Api from '../Base'

class GetTimelineBySpacePlan extends Api {
  requestUrl = `/api/SpacePlan/${this.getParams().id}/Timelines`
}
export default GetTimelineBySpacePlan
